import { CONSTANTS } from "../constants/constants";

const calcRowHeight = (width: number) => {
  // Logic below worsk only for 12 columns grid layout
  let blockW = (width - CONSTANTS.GRID_LAYOUT.GAP * 2) / 3; // find the width of a small widget block (width 4 and height 2)
  let blockH = blockW / CONSTANTS.GRID_LAYOUT.COEFFICIENT;  // find the best height for this block
  let rowH = (blockH - CONSTANTS.GRID_LAYOUT.GAP * 5) / 6;      // calculate the row height
  return Math.round(rowH);
}

export default calcRowHeight;